import React from "react";
import { View } from "react-native";
import Svg, {
  Path,
  Defs,
  LinearGradient,
  Stop,
  Rect,
  G,
  ClipPath,
} from "react-native-svg";
import { uniqueId } from "lodash";

export default function WandGradientIcon(props) {
  const width = props.width || 20;
  const height = props.height || 20;
  const clipId = "clip0" + uniqueId();
  const filterId = "paint0_linear" + uniqueId();
  const clipUrl = "url(#" + clipId + ")";
  const filterUrl = "url(#" + filterId + ")";

  return (
    <View style={props.style}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath={clipUrl}>
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.158 4.23895C18.7763 4.23895 19.2775 3.73774 19.2775 3.11947C19.2775 2.50121 18.7763 2 18.158 2C17.5398 2 17.0386 2.50121 17.0386 3.11947C17.0386 3.73774 17.5398 4.23895 18.158 4.23895ZM24.8186 9.15001C25.471 9.15001 25.9999 8.61102 25.9999 7.94615C25.9999 7.28128 25.471 6.74229 24.8186 6.74229C24.1661 6.74229 23.6372 7.28128 23.6372 7.94615C23.6372 8.61102 24.1661 9.15001 24.8186 9.15001ZM14.4621 9.74632C14.4621 10.3646 13.9609 10.8658 13.3426 10.8658C12.7244 10.8658 12.2231 10.3646 12.2231 9.74632C12.2231 9.12805 12.7244 8.62685 13.3426 8.62685C13.9609 8.62685 14.4621 9.12805 14.4621 9.74632ZM20.127 15.8387C20.7453 15.8387 21.2465 15.3375 21.2465 14.7193C21.2465 14.101 20.7453 13.5998 20.127 13.5998C19.5088 13.5998 19.0076 14.101 19.0076 14.7193C19.0076 15.3375 19.5088 15.8387 20.127 15.8387ZM23.716 4.28396C23.716 4.90223 23.2148 5.40344 22.5965 5.40344C21.9783 5.40344 21.4771 4.90223 21.4771 4.28396C21.4771 3.6657 21.9783 3.16449 22.5965 3.16449C23.2148 3.16449 23.716 3.6657 23.716 4.28396ZM14.3609 6.50602C14.9792 6.50602 15.4804 6.00482 15.4804 5.38655C15.4804 4.76828 14.9792 4.26707 14.3609 4.26707C13.7427 4.26707 13.2415 4.76828 13.2415 5.38655C13.2415 6.00482 13.7427 6.50602 14.3609 6.50602ZM25.111 12.244C25.111 12.8623 24.6098 13.3635 23.9915 13.3635C23.3733 13.3635 22.8721 12.8623 22.8721 12.244C22.8721 11.6258 23.3733 11.1246 23.9915 11.1246C24.6098 11.1246 25.111 11.6258 25.111 12.244ZM18.9175 11.0627H19.1425C19.6548 11.0516 20.1441 10.8473 20.5121 10.4906C20.88 10.1339 21.0996 9.6513 21.1266 9.13953C21.1537 8.62777 20.9862 8.1247 20.6579 7.73122C20.3296 7.33774 19.8646 7.08295 19.3562 7.01795C19.2832 7.01235 19.2099 7.01235 19.1369 7.01795C18.6241 7.02779 18.1341 7.23125 17.7652 7.58748C17.3963 7.9437 17.1758 8.42631 17.148 8.93839C17.1202 9.45046 17.2872 9.95409 17.6154 10.3481C17.9437 10.7422 18.4088 10.9974 18.9175 11.0627ZM17.2597 11.3506C17.7029 11.713 18.2416 11.9393 18.8106 12.0021L18.985 12.0134L7.95904 27.0447C7.86162 27.1778 7.73891 27.2904 7.59794 27.376C7.45696 27.4617 7.30048 27.5187 7.13746 27.5437C6.97443 27.5688 6.80806 27.5615 6.64787 27.5222C6.48767 27.4829 6.3368 27.4124 6.20388 27.3148L5.51194 26.8085C5.24757 26.611 5.07119 26.3177 5.0207 25.9917C4.97021 25.6656 5.04964 25.3327 5.24192 25.0646L16.3129 9.96008C16.4876 10.5053 16.8164 10.9882 17.2597 11.3506Z"
            fill={filterUrl}
          />
        </G>
        <Defs>
          <LinearGradient
            id={filterId}
            x1="5.00586"
            y1="7.54277"
            x2="18.7074"
            y2="30.5396"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <ClipPath id={clipId}>
            <Rect
              width="21"
              height="25.5567"
              fill="white"
              transform="translate(5 2)"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </View>
  );
}
